import React, { useContext } from "react";
import { UserContext } from "../Providers/UserProvider";
import Navbar from "../Components/Navbar";
import CreateJobForm from "../Components/CreateJobForm";

function JobForm() {

  const user = useContext(UserContext);

  return(
  	<>
  		<Navbar />
  		<section>
  			<h2>Post a Job</h2>
  			<CreateJobForm user={user} />
  		</section>
  	</>
  );
}

export default JobForm;